import Component from "../abstracts/Component";
export default class QuoteAnimationComponent extends Component {
  get SELECTORS() {
    return {
      main: '.c-editorial-quote',
      quote: '.wrapper-quote',
      writer: '.quote-writer',
    }
  }

  separateLetters(el){
    var textWrapper = el.innerHTML;
    var letters = textWrapper.split("");
    el.innerHTML = "";

    letters.forEach(function (letter) {
      var node = document.createElement("span");
      node.classList.add('letter');
      node.innerHTML = letter;
      el.appendChild(node);
    });
  }

  bindEvent(el) {

    this.separateLetters(el.querySelector(this.SELECTORS.quote));

    if (el.querySelector(this.SELECTORS.writer)){
      this.separateLetters(el.querySelector(this.SELECTORS.writer));
    } 

  }

  render() {

    var elements = document.querySelectorAll(this.SELECTORS.main);

    if (elements.length > 0) {
      elements.forEach(element => {
        this.bindEvent(element);
      });
    }
  }
}
